module.exports = __webpack_public_path__ + "img/Hero-mobile.e25424b5.svg";